export default "__VITE_ASSET__B8fym_Q8__"